import type { ChatType } from '../../components/chats'
import type { SidebarOptionKind } from '../../components/layout/sidebar/types'
import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@reduxjs/toolkit'

interface SidebarState {
  view?: SidebarView

  chats: {
    selectedTab?: ChatType
    selectedChatId?: string
    careTeamMemberId?: string
  }
}

export type SidebarView = SidebarOptionKind

let initialState: SidebarState = {
  chats: {}
}

let slice = createSlice({
  name: 'sidebar',
  initialState,

  reducers: {
    open (state, action: PayloadAction<SidebarView>) {
      state.view = action.payload
    },

    close (state) {
      state.view = undefined
      state.chats.selectedChatId = undefined
      state.chats.selectedTab = undefined
    },

    selectChat (state, action: PayloadAction<string>) {
      state.chats.selectedChatId = action.payload
    },

    clearSelectedChat (state) {
      state.chats.selectedChatId = undefined
    },

    selectTab (state, action: PayloadAction<ChatType>) {
      state.chats.selectedTab = action.payload
    },

    clearSelectedTab (state) {
      state.chats.selectedTab = undefined
    },

    setCareTeamMemberId (state, action: PayloadAction<string>) {
      state.chats.careTeamMemberId = action.payload
    },

    clearCareTeamMemberId (state) {
      state.chats.careTeamMemberId = undefined
    }
  }
})

export let { open, close, selectChat, clearSelectedChat, selectTab, clearSelectedTab, setCareTeamMemberId, clearCareTeamMemberId } = slice.actions
export default slice.reducer
